import api from 'api';
import {refreshCsrfOnce} from 'api/fetchCsrfToken';
import {safeFetch} from 'api/safeFetch';
import {useHandleApiErrorCallback} from 'common/hooks/useHandleApiErrorCallback';

export const useSSO = () => {
   const handleError = useHandleApiErrorCallback();

   const ssoLogin = async () => {
      console.debug('SSO Login');
      try {
         await refreshCsrfOnce();
      } catch (e) {
         console.error(e);
      }

      return safeFetch(api.ssoLogin, {redirect: 'follow'})
         .then((res) => {
            if (!res.ok) {
               throw res;
            }
            return res.text();
         })
         .then((redirectUrl) => {
            window.location.href = redirectUrl;
         })
         .catch(handleError({url: api.ssoLogin}));
   };

   return ssoLogin;
};
